import React, { useState } from 'react';
import styled from '@emotion/styled';

import Bag from './Bag';
import KebabMenu from './KebabMenu';
import PinkBoxEntry from './PinkBox';
import Translate from './Translate';
import Search from './Search';
import Zendesk from 'components/Zendesk';
import { getCartViewLocation } from './Notification/helpers';

const RightNav = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

interface RightNavProps {
  newNavEnabled: boolean;
}
const Index = ({ newNavEnabled }: RightNavProps) => {
  const [showZendeskChat, setShowZendeskChat] = useState(false);
  const cartViewLocation = getCartViewLocation();

  return (
    <>
      <RightNav>
        <Translate />
        <PinkBoxEntry />
        {newNavEnabled && <Search />}
        <Bag buttonId="header-bag-icon" pageSource={cartViewLocation} />
        <KebabMenu setShowZendeskChat={setShowZendeskChat} />
      </RightNav>
      {showZendeskChat && <Zendesk setShowZendeskChat={setShowZendeskChat} />}
    </>
  );
};

export default Index;
